import React from 'react';
import closeIcon from 'images/spinner.gif';
import { WaitingContainer } from './styles';

const WaitingModalContainer = () => (
  <WaitingContainer className="waiting-container">
    <img src={closeIcon} alt="" />
  </WaitingContainer>
);

export default WaitingModalContainer;
